module.exports = __webpack_public_path__ + "static/img/cabinet12_12.5819d1b2.gif";